
import { useDesignerStore } from "../store";

export default function ImageQualityPanel() {
  const width = useDesignerStore((state) => state.imageWidth);
  const height = useDesignerStore((state) => state.imageHeight);

  let quality = "No Image";
  let color = "text-gray-400";

  const longestSide = Math.max(width, height);

  if (longestSide >= 3000) {
    quality = "🟢 Excellent";
    color = "text-green-400";
  } else if (longestSide >= 2000) {
    quality = "🟢 Very Good";
    color = "text-green-300";
  } else if (longestSide >= 1200) {
    quality = "🟡 Good";
    color = "text-yellow-400";
  } else if (longestSide > 0) {
    quality = "🔴 Low Resolution";
    color = "text-red-400";
  }

  return (
    <div className="rounded-xl bg-slate-800 border border-slate-700 p-4 text-white">

      <h3 className="text-lg font-bold mb-4">
        🖼 Image Quality
      </h3>

      <div className="space-y-2 text-sm">

        <div className="flex justify-between">
          <span>Resolution</span>
          <span>
            {width} × {height}
          </span>
        </div>

        <div className="flex justify-between">
          <span>Status</span>
          <span className={color}>
            {quality}
          </span>
        </div>

      </div>

    </div>
  );
}